'use strict'
import {
	RECEIVE_ALL_CITIES,
	RECEIVE_ALL_DEPARTMENTS,
	RECEIVE_ALL_FILTER_TYPES,
	RECEIVE_ALL_INDICATOR_TYPES,
	RECEIVE_ALL_INDICATORS,
	RECEIVE_ALL_MANAGEMENT_WATER,
	RECEIVE_ALL_PARAMETERS,
	RECEIVE_ALL_REMARKS,
	RECEIVE_ALL_SITE_TYPES,
	RECEIVE_ALL_STANDARD_CODIFICATION,
	RECEIVE_ALL_STATIONS,
	RECEIVE_ALL_SUPPORTS,
	RECEIVE_ALL_UNITS,
	RECEIVE_ALL_WATERSHED,
	RESET_REFERENTIAL
} from '../constants/ReferentialConstants'

import DtoCity from '../dto/DtoCity'
import DtoUnit from '../dto/DtoUnit'
import DtoRemark from '../dto/DtoRemark'
import DtoSupport from '../dto/DtoSupport'
import DtoStandardCodification from '../dto/DtoStandardCodification'
import DtoParameter from '../dto/DtoParameter'
import DtoFilterType from '../dto/DtoFilterType'
import DtoSiteType from '../dto/DtoSiteType'
import DtoWatershed from '../dto/DtoWatershed'
import DtoSimpleStation from '../dto/DtoSimpleStation'
import DtoIndicatorType from '../dto/DtoIndicatorType'
import DtoIndicator from '../dto/DtoIndicator'
import DtoManagementWater from '../dto/DtoManagementWater'
import DtoDepartment from '../dto/DtoDepartment'

export const store = {
	units: [],
	remarks: [],
	supports: [],
	standardCodifications: [],
	parameters: [],
	cities: [],
	departments: [],
	filterTypes: [],
	siteTypes: [],
	watersheds: [],
	stations: [],
	indicatorTypes: [],
	indicators: [],
	managementWaters: []
}

export function ReferentialReducer(state = {}, action) {
	switch (action.type) {
		case RECEIVE_ALL_UNITS:
			return Object.assign({}, state, {
				units: action.units.map(o => new DtoUnit(o))
			})
		case RECEIVE_ALL_REMARKS:
			return Object.assign({}, state, {
				remarks: action.remarks.map(o => new DtoRemark(o))
			})
		case RECEIVE_ALL_SUPPORTS:
			return Object.assign({}, state, {
				supports: action.supports.map(o => new DtoSupport(o))
			})
		case RECEIVE_ALL_STANDARD_CODIFICATION:
			return Object.assign({}, state, {
				standardCodifications: action.standardCodifications.map(o => new DtoStandardCodification(o))
			})
		case RECEIVE_ALL_PARAMETERS:
			return Object.assign({}, state, {
				parameters: action.parameters.map(o => new DtoParameter(o))
			})
		case RECEIVE_ALL_CITIES:
			return Object.assign({}, state, {
				cities: action.cities.map(o => new DtoCity(o))
			})
		case RECEIVE_ALL_DEPARTMENTS:
			return Object.assign({}, state, {
				departments: action.departments.map(o => new DtoDepartment(o))
			})
		case RECEIVE_ALL_FILTER_TYPES:
			return Object.assign({}, state, {
				filterTypes: action.filterTypes.map(o => new DtoFilterType(o))
			})
		case RECEIVE_ALL_SITE_TYPES:
			return Object.assign({}, state, {
				siteTypes: action.siteTypes.map(o => new DtoSiteType(o))
			})
		case RECEIVE_ALL_WATERSHED:
			return Object.assign({}, state, {
				watersheds: action.watersheds.map(o => new DtoWatershed(o))
			})
		case RECEIVE_ALL_STATIONS:
			return Object.assign({}, state, {
				stations: action.stations.map(o => new DtoSimpleStation(o))
			})
		case RECEIVE_ALL_INDICATOR_TYPES:
			return Object.assign({}, state, {
				indicatorTypes: action.indicatorTypes.map(o => new DtoIndicatorType(o))
			})
		case RECEIVE_ALL_INDICATORS:
			return Object.assign({}, state, {
				indicators: action.indicators.map(o => new DtoIndicator(o))
			})
		case RECEIVE_ALL_MANAGEMENT_WATER:
			return Object.assign({}, state, {
				managementWaters: action.managementWaters.map(o => new DtoManagementWater(o))
			})
		case RESET_REFERENTIAL:
			return Object.assign({}, state, store)
		default:
			return state
	}
}



// WEBPACK FOOTER //
// ./src/referential/reducers/ReferentialReducer.js